import axios from "axios";
import Swal from "sweetalert2";
import {useEffect, useState} from "react";

export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_IP,
    timeout: 5000
})

axiosInstance.interceptors.response.use(
    (res) => res,
    (error) => {
        const requestUrl = error.config.url
        const status = Math.floor(error.response.status / 100)
        const status_code = error.response.status

        if (["/api/login", "/api/session/check"].includes(requestUrl)) {
            throw error
        }

        if (status === 5) {
            // console.log("서버 에러")
            Swal.fire({
                title: '알 수 없는 오류가 발생하였습니다.',
                text: '관리자에게 문의해주세요.',
                customClass: 'swal-alert',
                allowOutsideClick: false,
                confirmButtonText: '확인',
                confirmButtonColor: '#2D2D2D'
            }).then((_) => window.location = "/not-found")
            throw error
        }

        if (status_code === 401) {
            // console.log("session 권한 만료")
            Swal.fire({
                title: '로그인 시간이 만료되었습니다.',
                customClass: 'swal-alert',
                allowOutsideClick: false,
                confirmButtonText: '확인',
                confirmButtonColor: '#2D2D2D'
            }).then((_) => window.location = "/login")
            throw error
        }

        throw error
    }
)

export function useFetch(requester) {
    const [isLoading, setLoading] = useState(true)
    const [data, setData] = useState(null)
    const [error, setError] = useState(null)

    useEffect(() => {
        setLoading(true)
        requester()
            .then(res => {
                setData(res.data.result)
                if (res.data.error !== undefined) {
                    setError(res.data.error)
                }
            })
            .catch(error => setError(error))
            .finally(() => setLoading(false))
    }, [])

    return [isLoading, data, error]
}